<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：ダイアログ定義                                                               _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isConfirmShow">
    <div class="popup" style="width: 450px">
      <div class="popup-body">
        <div class="popup-status">
          <p class="popup-status-text newline">
            {{ message }}
          </p>
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button class="frm-btn strong large" @click="handleOK">OK</button>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/Base/BaseModal.vue";
export default {
  name: "STDSCM01C02LoginConfrimModal",
  components: { BaseModal },
  props: {
    message: {
      type: String,
      required: true,
    },
    isConfirmShow: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    // **********************************************
    // 「OK」ボタンをクリック
    // **********************************************
    handleOK() {
      this.$emit("agree", true);
    },
  },
};
</script>
